module.exports = __webpack_public_path__ + "img/ardoiz.199e57cb.jpg";